import { Outlet } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import PageNav from "@/components/layout/PageNav";
import Footer from "@/components/layout/Footer";
import PageFooterNav from "@/components/layout/PageFooterNav";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <PageNav />
      <main className="flex-1" id="main-content">
        <Outlet />
      </main>
      <PageFooterNav />
      <Footer />
      <Toaster richColors position="top-center" />
    </div>
  );
}
